import {
    post
} from '@/utils/request'
// 客服部-停车点申请-加载运营区域
export const partnerArea = data => post('/CityPartner/GET_ALL_Effective_city_partner_Area_NameList', data)
    // 客服部-停车点申请-加载列表
export const getEpcList = data => post('/ElectricPowerCart/GET_EpC_POINT_list', data)
    // 客服部-停车点申请-加载单个数据详情
export const getEpcDetal = data => post('/ElectricPowerCart/GET_EpC_POINT_DETAL', data)
    // 客服部-停车点申请-申请
export const opPoint = data => post('/ElectricPowerCart/oP_POINT', data)
    // 客服部-停车点申请-一键申请
export const opPointPass = data => post('/ElectricPowerCart/oP_POINT_One_button_pass', data)
    // 客服部-充值消费记录-查询列表
    // export const recordList = data => post('/CRM/Recharge_consumption_record_list', data)
export const recordList = data => post('/CRM/PersonalTransactionDetails', data)
    // 客服部-赠送金额-赠送金额
export const giveAmount = data => post('/FM/Give_a_virtual_amount', data)
    // 客服部-退余额列表-列表
export const balanceLis = data => post('http://139.224.204.55:7788/tlwewebapi/consumer/returnBalanceList', data)
    // 客服部-退余额列表-取消退款
export const cancelTF = data => post('/CRM/Cancel_transfer', data)
    // 客服部-退余额列表-修改状态/批量修改
export const agreeTF = data => post('/CRM/Agree_transfer', data)
    // 客服部-还车失败-列表
// export const returnFailLis = data => post('/CRM/findReturnFailList', data)
export const returnFailLis = data => post('http://139.224.204.55:7788/tlwewebapi/consumer/returnFailList', data)
    // 客服部-还车失败-加载车辆状态
export const loadBicycleLock = data => post('/CRM/bicycleBooleanlock', data)
    // 客服部-还车失败-车辆上锁
export const closeBicycleLock = data => post('/CRM/LockBatteryCart', data)
    // 客服部-还车失败-操作详情页
export const findFeedBack = data => post('/CRM/findFeedBack', data)
    // 客服部-还车失败-处理还车失败
    // export const dealFeedBack = data => post('/CRM/dealFeedBack', data)
export const dealFeedBack = data => post('http://139.224.204.55:7788/tlwewebapi/Failed-To-Return-OR-Order-Complaint/HQDOIT', data)
    // 客服部-还车失败-骑行券插入
export const insertLag = data => post('/CRM/AdD_Customer_service_pays_riding_Ticket_Flowing_list', data)
    // 客服部-订单投诉-列表
export const errorOrderLis = data => post('/CRM/Order_complaint_list', data)
    // 客服部-订单投诉-回滚
export const rollBackData = data => post('/CRM/RollbackToOrderComplaintPendingProcessing', data)
    // 客服部-订单投诉-添加流水
export const addOrderLius = data => post('/CRM/AddOrderComplaintRefundAmountFlowinglist', data)
    // 客服部-通用功能-查询
export const findByPhoneAndBicycle = data => post('/CRM/findByPhoneAndBicycle', data)
    // 客服部-通用功能-锁车
    // export const lockBicycle = data => post('/CRM/LockBatteryCart', data)
export const lockBicycle = data => post('http://139.224.204.55:7788/tlwewebapi/Electric-Bicycle/Lock/HQDOIT', data)
    // 客服部-通用功能-获取用户信息
export const getUserInfo = data => post('/CRM/Comm_get_UserInfo', data)
    // 客服部-通用功能-修改信用积分
export const updateCreditLine = data => post('/CRM/UpdateCreditLine', data)
    // 客服部-通用功能-减免移车费
export const commRemoveServicefee = data => post('/CRM/CommRemoveServicefee', data)
    // 客服部-通用功能-查询验证码
export const queryCode = data => post('/CRM/Query_verification_code', data)
    // 客服部-通用功能-清除押金
export const clearUserDeposit = data => post('/CRM/clearUserDeposit', data)
    // 客服部-通用功能-强制开锁
    // export const unlockBatteryCart = data => post('/CRM/unlockBatteryCart', data)
export const unlockBatteryCart = data => post('http://139.224.204.55:7788/tlwewebapi/Electric-Bicycle/Unlock/HQDOIT', data)
    // 客服部-通用功能-修复还车界面消失
export const repairBicycleInterfaceDisappears = data => post('/CRM/RepairBicycleInterfaceDisappears', data)
    // 客服部-通用功能-修复车辆无法被使用
export const clearBicycleRedisLocked = data => post('/CRM/ClearBicycleRedisLocked', data)
    // 客服部-通用功能-修复车辆无法被使用
export const fixBikeState = data => post('http://139.224.204.55:7788/tlwewebapi/Electric-Bicycle/Edit-PerfectState/HQDOIT', data)
    // 客服部-通用功能-注销用户
export const closeAccount = data => post('http://139.224.204.55:7788/tlwewebapi/User/CloseAccount/HQDOIT', data)
    // 客服部-通用功能-修改费用
export const editRidingMoney = data => post('http://139.224.204.55:7788/tlwewebapi/Modification-Costs/EPCReturnedButUnpaidDoit', data)

    // 客服部-通用功能-获取账单
    // export const commBilling = data => post('/CRM/CommBilling', data)
export const commBilling = data => post('http://139.224.204.55:7788/tlwewebapi/customerservice/hq/obtainingNeedToPay', data)
    // 客服部-通用功能-支付订单
    // export const commBilling = data => post('/CRM/CommBilling', data)
export const PayReturnedOrder = data => post('http://139.224.204.55:7788/tlwewebapi/consumer/PayReturnedOrder', data)


    // 客服部-通用功能-还车操作（正常计费、0元、1元）
    // export const commReturnEPC = data => post('/CRM/CommReturnEPC', data)
export const commReturnEPC = data => post('http://139.224.204.55:7788/tlwewebapi/General-Return-Electric-Bicycle/HQDOIT', data)
    // 客服部-通用功能-获取骑行券列表
export const getEffectiveUserRideTicketList = data => post('/RideTicket/GetEffectiveUserRideTicketList', data)
    // 客服部-通用功能-身份证查询y
export const findByCardOrPhone = data => post('/CRM/Comm_findUserByIdCardOrPhoneNumber', data)
    // 客服部-通用功能-订单号查询
export const findPayOrderno = data => post('/CRM/Comm_get_balancerecord_Flows_By_PayOrderno', data)
    //客服部 -退余额列表-添加余额退款流水
export const addBalanceLis = data => post('/CRM/AddBalanceRefundFlow', data)
    //客服部 -退余额列表-添加押金退款流水
export const addDepositLis = data => post('/CRM/AddRefundDepositRecord', data)
    //客服部 -充值消费记录- 修改费用
export const showMoPrice = data => post('/CRM/ShowDirectlyModifyThePrice', data)
    //客服部 -充值消费记录- 修改费用
export const editMoPrice = data => post('/CRM/DoDirectlyModifyThePrice', data)
    //客服部 -通用功能- 查询运维
export const findPSMan = data => post('/CRM/CommfindPartnerStaffinfoByPhone', data)
    //客服部 -通用功能- 修改运维
export const editSFB = data => post('/CRM/CommeditPartnerStaffinBelong', data)
    //客服部 -订单投诉- 直接退款
export const orderCRTRA = data => post('/CRM/OrderComplaintRefundAmountToRidingAccount', data)
    //财务部 -相关统计
export const financialRs = data => post('/FM/newUserSomeTongJiForIN18', data)
    // 客服部充值消费处理用户投诉中一键退回此订笔交易费用
export const OrderAmount = data => post('http://139.224.204.55:7788/tlwewebapi/One-Click-Refund-Of-Order-Amount/One-Click-Refund-Of-Order-Amount', data)
    // 客服部修改费用
    // export const CPDOIT = data => post('http://139.224.204.55:7788/tlwewebapi/Modification-Costs/CPDOIT', data)
export const CPDOIT = data => post('http://139.224.204.55:7788/tlwewebapi/Modification-Costs/HQDOIT', data)
    // 客服部通过身份证查询手机号
export const HQDOIT = data => post('http://139.224.204.55:7788/tlwewebapi/Query-User-Information-Based-On-IDCard/HQDOIT', data)
export const getRFbye = data => post('/CRM/CommGetUserRefundBalance', data)
export const CancelRefund = data => post('http://139.224.204.55:7788/tlwewebapi/consumer/CancelRefund', data)
export const wxMonths = data => post('/CRM/WeChat_recharge_record_in_the_past_3_months', data)
export const originalOtag = data => post('/CRM/Operation_User_unpaid_debit_orders', data)
export const personOROList = data => post('/CRM/PersonalOrdersRidingDetails', data)
export const showPersonORODetail = data => post('/CRM/show_PersonalOrdersRidingDetails', data)
export const showUserCSRecord = data => post('/CRM/UserCreditScoreDetails', data)
    // 通用功能合并号码
export const changeNewToOld = data => post('http://139.224.204.55:7788/tlwewebapi/Merge-User-Mobile-Phone-Number/Approved/HQDOIT', data)
    // 合并号码列表
export const mergeUMPNList = data => post('http://139.224.204.55:7788/tlwewebapi/Merge-User-Mobile-Phone-Number/List/HQDOIT', data)
    // 合并号码列表 驳回
export const changeNewReject = data => post('http://139.224.204.55:7788/tlwewebapi/Merge-User-Mobile-Phone-Number/Reject/HQDOIT', data)
    // 通用功能 正常计费 骑行卡列表
export const rideCardList = data => post('http://139.224.204.55:7788/tlwewebapi/Ride-Card/Belongs-To-User/List', data)
    // 充值消费记录 记录查询
export const statistics = data => post('http://139.224.204.55:7788/tlwewebapi/User/Transaction/Statistics', data)
    // 充值消费记录 申请退款
export const applyRefund = data => post('http://139.224.204.55:7788/tlwewebapi/User/BalanceRefund/Apply', data)
    // 赠送余额 人脸识别
export const faceOnOff = data => post('/CityPartner/Config_FaceAuth_On_OR_Off', data)
    // 赠送余额 人脸识别
export const showFaceOnOff = data => post('/CityPartner/Show_FaceAuth_On_OR_Off', data)
    // 通用功能 查询1 
    // export const getVLUBasicInfo = data => post('http://139.224.204.55:7788/tlwewebapi/customerservice/hq/getVehicleLastUsageBasicInfo', data)
export const getGeneralQuery = data => post('http://139.224.204.55:7788/tlwewebapi/customerservice/hq/generalQuery', data)
    // 通用功能 查询2
export const getVLUEPCInfo = data => post('http://139.224.204.55:7788/tlwewebapi/customerservice/hq/getVehicleLastUsageEPCInfo', data)
    // 通用功能 查询3
export const getVLUMapInfo = data => post('http://139.224.204.55:7788/tlwewebapi/customerservice/hq/getVehicleLastUsageMapInfo', data)
    // 还车失败  订单投诉 查询1
export const getProblemFeedBackInfo = data => post('http://139.224.204.55:7788/tlwewebapi/customerservice/hq/getProblemfeedbackInfo', data)
    // 还车失败  订单投诉 查询2
export const getProblemFeedBackMapInfo = data => post('http://139.224.204.55:7788/tlwewebapi/customerservice/hq/getProblemfeedbackMapInfo', data)
   // 查询计费规则
   export const ShowPriceConfigure = data => post('http://139.224.204.55:7788/tlwewebapi/operatingarea/ShowPriceConfigure', data)
   // 问题车俩
export const Problemcars = data => post('/ElectroBicycle/问题车辆列表', data,'9999')
// 问题车辆运营区域
export const getpartnerArea = data => post('/Common/获取', data,'9999')
// 问题车辆处理
export const setbicytype = data => post('/ElectroBicycle/处理问题车辆', data,'9999')